"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ws_1 = require("@apollo/client/link/ws");
const subscriptions_transport_ws_1 = require("subscriptions-transport-ws");
const getJWT_1 = (0, tslib_1.__importDefault)(require("../auth/getJWT"));
const getSession_1 = (0, tslib_1.__importDefault)(require("../auth/getSession"));
const getSignature_1 = (0, tslib_1.__importDefault)(require("../auth/getSignature"));
const getConnectionParams = function () {
    let params = {};
    const session = (0, getSession_1.default)();
    const jwt = (0, getJWT_1.default)();
    if (jwt) {
        params = {
            jwt
        };
    }
    else if (session) {
        const { publicKey, secretKey } = session;
        if (publicKey && secretKey) {
            const nonce = new Date().getTime();
            const signature = (0, getSignature_1.default)(nonce + 'websockethandshake', session);
            params = {
                nonce,
                publicKey,
                signature
            };
        }
    }
    return params;
};
function createWsLink(options) {
    const { endpointURL, subscriptionsPath } = options;
    const uri = endpointURL.replace('http', 'ws') + subscriptionsPath;
    const client = new subscriptions_transport_ws_1.SubscriptionClient(uri, {
        reconnect: true,
        lazy: true,
        reconnectionAttempts: 10,
        connectionParams: getConnectionParams,
        ...options.wsOptions
    });
    options.wsClient = client;
    return new ws_1.WebSocketLink(client);
}
exports.default = createWsLink;
